import Percentage from './PercentageGrading';

export default Percentage;
